import { Card, Col, Container, Row } from 'react-bootstrap';
import BranchForm from './BranchForm';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';
import { useContext } from 'react';
import AuthContext from 'context/authContext';
import useUpload from 'hooks/useUpload';
import { useCreateBranch } from 'hooks/useBranches';

// ------------------------------

export default function CreateBranch() {
  const navigate = useNavigate();
  const { organization } = useContext(AuthContext);

  // Use Supabase hooks
  const { createBranchAsync, isCreating } = useCreateBranch();
  const { upload, loading: uploadLoading } = useUpload();

  const onSubmit = async values => {
    let logo = values.logo;
    try {
      // Upload logo if it's a new file
      if (logo && typeof logo !== 'string') {
        const profileUrl = await upload(logo, 'branches');
        logo = profileUrl;
      }

      // Create branch in Supabase
      await createBranchAsync({
        name: values.name,
        address: values.address || '',
        city: values.city,
        currency_id: values.currency_id,
        location_id: values.location_id,
        logo: logo || '',
        organisation_id: organization.id,
        phone: values.phoneNumber || ''
      });

      // Navigate back to branches list on success
      navigate(paths.branchesSetting);
    } catch (e) {
      console.error('Create branch error:', e);
      toast.error('Something went wrong! Please try again later!');
    }
  };

  return (
    <Container fluid className="px-0">
      <Row>
        <Col sm={12} md={7}>
          <Card>
            <Card.Body>
              <BranchForm
                loading={isCreating || uploadLoading}
                onSubmit={onSubmit}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
